<organization-select        #orgManager
                            autoSelectFirst = "true"
                            class = "mr-3"></organization-select>        
                                            
<site-select                #siteManager
                            [org]           =   "orgManager?.currentValue"
                            autoSelectFirst =   "true"
                            class           =   "mr-3"
                            (change)        =   "setSite($event)"></site-select>

<device-select              #deviceManager
                            [site]          =   "siteManager?.currentValue"
                            autoSelectFirst =   "true"
                            class           =   "mr-3"
                            type            =   "0"
                            enabled         =   "0"
                            (change)        =   "setDevice($event)"></device-select>

<br>

<help-alert text = "help.page.device.field" info = "help.info" description = "help.page.device.description" action = "help.page.device.action"></help-alert>

<br>
<br>

<device-data-container      [deviceDetail] = "values"   
                            [site]         = "site" 
                            (refresh)      = "reloadData()">
    
</device-data-container>